module.exports = __webpack_public_path__ + "img/version0.160474a5.jpg";